export default "/kiban/_next/static/images/cupper-6cd1a9548340c3637211ca5e39d0ef0b.png";